<div [ngSwitch]="type">
  <div *ngSwitchCase="'progress_bar'">
    <div>
      <div
        class="seds-flex seds-flex-row seds-justify-center custom-progress-bar-spinner"
        *ngSwitchCase="'progress_bar'">
        <div class="seds-grow seds-px-2" tabindex="0">
          <mat-progress-bar [mode]="mode" [value]="resultPercentage"></mat-progress-bar>
        </div>
        <div *ngIf="percentage" class="seds-shrink-0">
          <p class="seds-subtitle-2">{{ resultPercentage }} %</p>
        </div>
      </div>
      <div *ngIf="percentage">
        <p class="seds-subtitle-2">Loading...</p>
      </div>
    </div>
  </div>

  <div *ngSwitchCase="'progress_spinner'">
    <div class="seds-flex custom-progress-bar-spinner" tabindex="0">
      <mat-spinner
        [diameter]="48"
        *ngSwitchCase="'progress_spinner'"
        [mode]="mode"
        [value]="resultPercentage"></mat-spinner>
    </div>
  </div>

  <div *ngSwitchCase="'logo'" class="seds-flex">
    <div class="fade-in image-container" aria-label="Carregando" tabIndex="0">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="seds-loaders-brand-svg"
        [ngClass]="{
          'logo-lg': size === 'large' ? true : false,
          'logo-md': size === 'standard' ? true : false,
          'logo-sm': size === 'small' ? true : false,
        }"
        viewBox="0 0 99.211 121.89"
        shape-rendering="geometricPrecision"
        text-rendering="geometricPrecision">
        <g class="seds-loaders-brand-svg--outer-1" transform="translate(80.077003,33.527) scale(1,1)">
          <g class="seds-loaders-brand-svg--inner-1" transform="translate(-80.077003,-33.527)">
            <path
              d="M83.155,39.9h-6.148c-1.823448-.000546-3.30259-1.476557-3.307-3.3v-6.14c-.001105-1.82712,1.47888-3.309344,3.306-3.311h6.148c1.825463.003311,3.302764,1.485536,3.3,3.311v6.14c.001327.87608-.345764,1.716733-.964778,2.336685s-1.459141.968316-2.335222.968315"
              fill="#ba2f7d" />
          </g>
        </g>
        <g class="seds-loaders-brand-svg--outer-2" transform="translate(54.448002,24.094499) scale(1,1)">
          <g class="seds-loaders-brand-svg--inner-2" transform="translate(-54.448002,-24.094499)">
            <path
              d="M59.911,35.433h-10.923c-1.559197.000531-3.0547-.618555-4.157313-1.72098s-1.721952-2.597823-1.721687-4.15702v-10.923c.000265-1.558851.619839-3.053735,1.722394-4.155727s2.597755-1.720804,4.156606-1.720273h10.923c3.244996.000552,5.875448,2.631004,5.876,5.876v10.923c.000265,1.558677-.618663,3.053621-1.720626,4.155959s-2.596697,1.721776-4.155374,1.722041"
              transform="matrix(.720849 0 0 0.720849 15.199215 6.726004)"
              fill="#406eb3" />
          </g>
        </g>
        <g class="seds-loaders-brand-svg--outer-3" transform="translate(25.512001,47.158001) scale(1,1)">
          <g class="seds-loaders-brand-svg--inner-3" transform="translate(-25.512,-47.158001)">
            <path
              d="M31.655,59.916h-12.287c-1.753671.001327-3.435928-.694591-4.676148-1.934437s-1.936649-2.921891-1.935852-4.675563v-12.29c-.000531-1.754142.695791-3.436649,1.935781-4.67739s2.922077-1.93808,4.676219-1.93861h12.287c3.65125.000552,6.611344,2.959751,6.613,6.611v12.29c.000797,1.753845-.695768,3.436043-1.936205,4.675917s-2.92295,1.935676-4.676795,1.934083"
              fill="#632678" />
          </g>
        </g>
        <g class="seds-loaders-brand-svg--outer-4" transform="translate(26.7315,77.625) scale(1,1)">
          <g class="seds-loaders-brand-svg--inner-4" transform="translate(-26.731499,-77.625)">
            <path
              d="M30.485,85.42h-7.505c-1.072352.000531-2.100964-.425087-2.859419-1.183167s-1.184581-1.786481-1.184581-2.858833v-7.5c-.000796-1.073147.424884-2.102628,1.183338-2.861833s1.787515-1.185902,2.860662-1.186167h7.505c1.07279.000265,2.101493.426889,2.859601,1.185935s1.18346,1.788275,1.182399,2.861065v7.5c.000531,1.072168-.425151,2.100575-1.183288,2.858712s-1.786544,1.183819-2.858712,1.183288"
              fill="#982881" />
          </g>
        </g>
        <g class="seds-loaders-brand-svg--outer-5" transform="translate(46.1985,99.921502) scale(1,1)">
          <g class="seds-loaders-brand-svg--inner-5" transform="translate(-46.198499,-99.921501)">
            <path
              d="M50.635,109.134h-8.873c-1.266826.001062-2.482086-.501644-3.377961-1.397331s-1.398836-2.110843-1.398039-3.377669v-8.874c-.000797-1.266918.502132-2.482175,1.397978-3.378022s2.111104-1.398775,3.378022-1.397978h8.873c1.266918-.000797,2.482175.502132,3.378022,1.397978s1.398775,2.111104,1.397978,3.378022v8.874c.000797,1.266826-.502163,2.481981-1.398039,3.377669s-2.111135,1.398393-3.377961,1.397331"
              fill="#ba2f7d" />
          </g>
        </g>
      </svg>
      <svg
        class="s-logo"
        [ngClass]="{
            's-lg': size === 'large' ? true : false,
            's-md': size === 'standard' ? true : false,
            's-sm': size === 'small' ? true : false,
          }"
        viewBox="0 0 23 37"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M16.7209 17.9649C14.6034 16.78 12.4234 15.6922 10.3216 14.4892C9.45249 14.0058 8.65672 13.4026 7.95796 12.6976C7.57824 12.3545 7.28486 11.9277 7.10137 11.4515C6.91789 10.9753 6.84942 10.463 6.90148 9.95577C6.95353 9.44852 7.12466 8.96047 7.4011 8.53085C7.67754 8.10122 8.05159 7.742 8.49319 7.48206C9.09068 7.16028 9.74348 6.95233 10.4179 6.86892C12.3293 6.64731 14.2589 7.09172 15.877 8.12624C16.7444 8.62694 17.6851 8.99006 18.6652 9.20247C19.1488 9.29172 19.6482 9.23302 20.0975 9.03415C20.5468 8.83527 20.9247 8.50559 21.1812 8.08873C21.4687 7.71285 21.6326 7.25808 21.6505 6.78634C21.6685 6.31461 21.5396 5.84885 21.2814 5.45249C20.8733 4.75889 20.3411 4.14516 19.7109 3.64154C17.3696 1.90313 14.5248 0.963807 11.6017 0.963907C9.44627 0.958525 7.32547 1.50232 5.44198 2.54332C3.47603 3.59575 1.97885 5.34218 1.24614 7.43771C0.513421 9.53324 0.598434 11.8255 1.48439 13.8618C2.34809 15.9172 3.9003 17.613 5.87824 18.6621C7.59462 19.6465 9.38394 20.4977 11.1433 21.4057C12.6528 22.1034 14.0286 23.0567 15.209 24.2231C15.8745 24.7862 16.3181 25.5651 16.4611 26.4219C16.6041 27.2786 16.4373 28.158 15.9903 28.9044C15.6495 29.3876 15.2077 29.7921 14.695 30.0901C14.1823 30.3881 13.6109 30.5727 13.0199 30.6313C10.7359 30.977 8.40508 30.4475 6.49942 29.1502C5.81763 28.6865 5.09186 28.29 4.33244 27.9666C3.87578 27.7527 3.36787 27.6704 2.86645 27.729C2.36504 27.7876 1.89022 27.9847 1.49599 28.298C1.10177 28.6113 0.803936 29.0282 0.636362 29.5012C0.468789 29.9743 0.438195 30.4846 0.548058 30.974C0.769502 31.909 1.30622 32.7407 2.06911 33.3309C4.18237 34.9953 6.71693 36.0484 9.39389 36.3743C12.0708 36.7002 14.7864 36.2863 17.2418 35.1781C18.3829 34.637 19.3999 33.8689 20.2299 32.9214C21.0599 31.974 21.6852 30.8673 22.067 29.6699C22.4487 28.4726 22.5789 27.2101 22.4494 25.9608C22.3199 24.7115 21.9334 23.5018 21.314 22.4069C20.2704 20.499 18.6689 18.9502 16.7209 17.9649V17.9649Z"
          fill="#1D4F91" />
      </svg>
    </div>
  </div>
</div>
